import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import Icon from '../../../../components/AppIcon';
import {submitNewPassword} from '../../../../services/accountService';
import { toast } from 'react-toastify';

const PasswordResetForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
    otp: '',
    resetId: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors?.[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.otp) {
      newErrors.otp = 'OTP is required';
    } else if (formData?.otp?.length !== 6) {
      newErrors.otp = 'OTP must be 6 characters';
    }

    if (!formData?.newPassword) {
      newErrors.newPassword = 'New password is required';
    } else if (formData?.newPassword?.length < 8) {
      newErrors.newPassword = 'New password must be at least 8 characters';
    }

     if (!formData?.confirmPassword) {
      newErrors.confirmPassword = 'Confirm password is required';
    } else if (formData?.newPassword !== formData?.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };


  const handleSubmitPasswordReset = async (e) => {
    e?.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    const response = await submitNewPassword(formData);
    if(response && response.success){
      toast.success(response?.message || 'Password reset successfully.');
      setIsLoading(false);
      navigate('/login');
    }
    else{
      toast.error(response?.message || 'Failed to reset password. Please try again.');
      setIsLoading(false);

      if(response?.errors){
        const newErrors = {};
        newErrors.submit = response?.errors || 'Failed to reset password. Please try again.';
        setErrors(newErrors);
      }
    }
  }

  useEffect(() => {
    //Get resetId from URL query params
    const urlParams = new URLSearchParams(window.location.search);
    const resetId = urlParams.get('id');
    if(resetId){
      setFormData(prev => ({
        ...prev,
        resetId: resetId}));
    }
    else{
      toast.error('Invalid password reset link. Please try again.');
      navigate('/login');
    }  
    }, []);

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmitPasswordReset} className="space-y-5">
        {/* Email Input */}
        <Input
          label="One Time Pin (OTP)"
          type="text"
          name="otp"
          placeholder="Enter your OTP"
          value={formData?.otp}
          onChange={handleInputChange}
          error={errors?.otp}
          required
          disabled={isLoading}
          className="w-full"
        />

        <Input
          label="New Password"
          type="password"
          name="newPassword"
          placeholder="Enter your new password"
          value={formData?.newPassword}
          onChange={handleInputChange}
          error={errors?.newPassword}
          required
          disabled={isLoading}
          className="w-full"
        />

        <Input
          label="Confirm New Password"
          type="password"
          name="confirmPassword"
          placeholder="Confirm your new password"
          value={formData?.confirmPassword}
          onChange={handleInputChange}
          error={errors?.confirmPassword}
          required
          disabled={isLoading}
          className="w-full"
        />

        {/* Submit Error */}
        {errors?.submit && (
          <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
            <div className="flex items-center space-x-2">
              <Icon name="AlertCircle" size={16} className="text-destructive" />
              <span className="text-sm text-destructive">{errors?.submit}</span>
            </div>
          </div>
        )}

        {/* Sign In Button */}
        <Button
          type="submit"
          variant="default"
          size="lg"
          loading={isLoading}
          disabled={isLoading}
          iconName={isLoading ? undefined : "LogIn"}
          iconPosition="left"
          iconSize={18}
          className="w-full"
        >
          Set New Password
        </Button>
      </form>
    </div>
  );
};

export default PasswordResetForm;